module.exports = __webpack_public_path__ + "static/media/Statement of Allegations LJM Developments (Stoney Creek) Inc. signed.8f66a57b.pdf";